/* eslint-disable no-unused-vars */
import { isDev, isStaging } from 'constants/api';

import { CueAnalytics } from '@cuemath/analytics-v2';
import { getTestEnvironmentName } from '@cuemath/analytics-v2/dist/constants';
import webengagePlugin from '@cuemath/analytics-v2/dist/plugins/webengage';
import { getDataFromLocalStorage } from 'utils';

import { IS_DEBUG_MODE } from './constants';
import { mixPanelPlugin, isMixpanelEnabled } from './plugins/mixpanel';

const getEnvironment = () => {
  if (isDev) {
    return 'DEVELOPMENT';
  }

  if (isStaging) {
    return 'TESTING';
  }

  return 'PRODUCTION';
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const getBaseURL = () => {
  if (isDev) {
    return 'https://insightcollector.testenv10.cuemath.com/';
  }

  if (isStaging) {
    return `https://insightcollector.${getTestEnvironmentName()}.cuemath.com`;
  }

  return 'https://insightcollector.cuemath.com';
};

const caPlugins = [
  webengagePlugin({
    webengage: undefined,
    trackAllEvents: false,
  }),
];

if (isMixpanelEnabled) {
  caPlugins.push(mixPanelPlugin);
}

const areCueLogsEnabled = () => {
  if (isDev) return true;

  const isDebugMode = getDataFromLocalStorage(IS_DEBUG_MODE);

  return isDebugMode === true;
};

const getAppBuildNumber = () => {
  const buildNumber = Number(process.env.REACT_APP_BUILD_NUMBER) || 0;

  return buildNumber;
};

const analytics = new CueAnalytics({
  // Uncomment baseURL if you need to send events in developement environment
  // baseURL: getBaseURL(),
  environment: getEnvironment(),
  userType: 'STUDENT',
  appId: 'leap.cuemath.com',
  appVersion: '0.0.0',
  appBuildNumber: getAppBuildNumber(),
  logEnabled: areCueLogsEnabled(), // If true, This logs data in the console. Check inspect in browser.
  logLevel: 'info',
  storage: window.localStorage,
  plugins: caPlugins,
});

export const trackEvent = (
  eventName: string,
  eventData: Record<string, any>,
  overrides?: Record<string, any>,
) => {
  //TODO: Integrate mixpanel in future
  analytics.trackEvent(eventName, eventData, overrides);
};

export default analytics;
